module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA0UlEQVQ4T82SrQ7CQBCEdzUWjUbzLpAgCOlcUASBQoHAIQgKBTsNqg0oFAqH4qWOtAHCTyFtKuDk3c3cN7OnUnJpSb38iQFJD6AQDcktgFYqItkWkTWASp5OzGyvqjGA6P4qya6IzAFUv5mY2eEq3iT3nrDNrKeqYwC1LBOSR+997Jxb3c7fcptZX1UHAOqPJmZ2EpHIObd83M8sjuRQRDoAGteOzokYwOKV7GPzYRiOvPfNNKfqLgiCWVasr6MjOUlEAKafii00+8IEef7E7wkuDvJEEQLKna8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/cart_feature_down.png
// module id = c0GI
// module chunks = 1